/**
 * The audits and certifications shown on /security, read by both pages (today's src/pages/Security.tsx and the new
 * design's PavilionSecurity.tsx).
 *
 * ACCURACY RULE (2026-09-09 owner ruling — sweep, not patch; 2026-10-16, Miles: the status of Prest0's own audits,
 * said as it stands). Prest0's own SOC 2 Type 1, SOC 2 Type 2 and HIPAA cards take their words and their state from
 * src/config/complianceStatus.generated.ts (config/compliance-status.json): a card names a report as held only once
 * the auditor has issued it, and changes with that one file. Google Cloud's SOC 2 Type II and ISO/IEC 27001 are named
 * as Google's, for the infrastructure underneath us, and as inherited.
 *
 * NO PICTURE OF A SEAL. Until 2026-10-16 each card was a picture: an AICPA "SOC for Service Organizations" mark, an
 * "ISO 27001 Certified" seal, a "Zero training on user data certified" seal and a "TLS 1.3 verified secure" one. None
 * was Prest0's to show (the AICPA's mark is for an organization whose SOC examination is complete, and nobody had
 * certified the others), and a picture says "certified" whatever the words beside it say. Each card is now the page's
 * own glyph, its name, its state and its words.
 */
import { COMPLIANCE } from '../config/complianceStatus.generated';

export type CertificationGlyph = 'award' | 'clock' | 'heart' | 'cloud';

export type CertificationBadge = {
  id: string;
  label: string;
  /** Where it stands, in the page's closed list of statuses (src/config/securityStatuses.ts). */
  state: string;
  glyph: CertificationGlyph;
  text: string;
};

export const certificationBadges: CertificationBadge[] = [
  { id: 'soc2-type1', label: COMPLIANCE.soc2Type1.name, state: COMPLIANCE.soc2Type1.state, glyph: 'award', text: COMPLIANCE.soc2Type1.sentence },
  { id: 'soc2-type2', label: COMPLIANCE.soc2Type2.name, state: COMPLIANCE.soc2Type2.state, glyph: 'clock', text: COMPLIANCE.soc2Type2.sentence },
  { id: 'hipaa', label: COMPLIANCE.hipaa.name, state: COMPLIANCE.hipaa.state, glyph: 'heart', text: COMPLIANCE.hipaa.sentence },
  {
    id: 'google-cloud',
    label: 'Google Cloud infrastructure',
    state: 'inherited',
    glyph: 'cloud',
    text: COMPLIANCE.infrastructure,
  },
];
